export const ERROR_KEYS = {
  PYTHON_EXPRESSION_TEST_FAILED: 'PythonExpressionTestFailed'
} as const;
